import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { DropdownItems } from '~/chords/Select/components/DropdownTreeSingleSelect/components/DropdownItems';
import type { RadixUiProps } from '~/chords/Select/components/DropdownTreeSingleSelect/types';

interface DropdownNoOptionsAvailableProps extends RadixUiProps {
  labelText?: string;
  labelNode?: ReactNode;
}

export function DropdownNoOptionsAvailable({
  labelText,
  labelNode,
  radix = {},
}: DropdownNoOptionsAvailableProps) {
  const { t } = useTranslation('common');

  return (
    <DropdownItems
      depth={0}
      options={[
        {
          value: 'none',
          label: labelText || t('dropdownTree.noOptions'),
          isVisible: true,
          isExpanded: false,
          isSelected: false,
          hasSelected: false,
          optionIndexPath: [],
        },
      ]}
      showCheckIcon={false}
      OptionTemplate={({ option }) => labelNode || option.label}
      radix={{
        ...radix,
        selectItem: {
          ...radix.selectItem,
          value: 'none',
          className: 'pointer-events-none',
        },
      }}
    />
  );
}

DropdownNoOptionsAvailable.displayName = 'DropdownNoOptionsAvailable';
